<template>
  <div class="withdraw_index">
    <div class="withdraw_index_nav">
      <navbar
        title="提现详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row>
        <!-- 提现驳回 -->
        <van-col
          span="24"
          class="operate_status"
          v-if="detailInfo.status == 3 || detailInfo.status == 6"
        >
          <div class="step passed">
            <p class="tit">发起提现申请</p>
            <p class="time">{{ detailInfo.created_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/passed.png" />
            <span class="line"></span>
          </div>
          <div class="step passed">
            <p class="tit">提现处理中</p>
            <p class="time">{{ detailInfo.withdrawal_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/passed.png" />
            <span class="line"></span>
          </div>
          <div class="step current">
            <p class="tit">提现驳回</p>
            <p class="time">{{ detailInfo.alipay_op_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/failed.png" />
          </div>
        </van-col>
        <!-- 提现成功 -->
        <van-col
          span="24"
          class="operate_status"
          v-else-if="detailInfo.status == 2"
        >
          <div class="step passed">
            <p class="tit">发起提现申请</p>
            <p class="time">{{ detailInfo.created_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/passed.png" />
            <span class="line"></span>
          </div>
          <div class="step passed">
            <p class="tit">提现处理中</p>
            <p class="time">{{ detailInfo.withdrawal_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/passed.png" />
            <span class="line"></span>
          </div>
          <div class="step current">
            <p class="tit">提现成功</p>
            <p class="time">{{ detailInfo.alipay_op_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/success.png" />
          </div>
        </van-col>
        <!-- 提现处理中 -->
        <van-col span="24" class="operate_status" v-else>
          <div class="step passed">
            <p class="tit">发起提现申请</p>
            <p class="time">{{ detailInfo.created_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/passed.png" />
            <span class="line"></span>
          </div>
          <div class="step current middle">
            <p class="tit">提现处理中</p>
            <p class="time">{{ detailInfo.withdrawal_at }}</p>
            <img src="@/assets/purchaseSupplier/withdraw/current.png" />
            <span class="line"></span>
          </div>
          <div class="step nature last">
            <p class="tit">提现成功</p>
            <img src="@/assets/purchaseSupplier/withdraw/nature.png" />
          </div>
        </van-col>

        <van-col span="24" class="item">
          提现金额
          <span>{{ detailInfo.balance }}</span>
        </van-col>
        <van-col span="24" class="item">
          提现方式
          <span v-if="detailInfo.type == 2">余额账户</span>
          <span v-if="detailInfo.type == 4">对公账户</span>
          <span v-if="detailInfo.type == 5">企业支付宝</span>
        </van-col>
        <van-col span="24" class="item">
          提现账户
          <span>{{ detailInfo.account }}</span>
        </van-col>
        <van-col
          span="24"
          class="item"
          :class="{ last: !(detailInfo.status == 3 || detailInfo.status == 6) }"
        >
          提现单号
          <span>{{ detailInfo.ordersn }}</span>
        </van-col>
        <van-col
          v-if="detailInfo.status == 3 || detailInfo.status == 6"
          span="24"
          class="item"
          :class="{ last: detailInfo.status == 3 || detailInfo.status == 6 }"
        >
          驳回原因
          <span>{{ detailInfo.reason }}</span>
        </van-col>
        <van-col span="24">
          <btn
            :btntext="'返回'"
            :btnwidth="'30.9rem'"
            :height="'4.8rem'"
            :bgcolor="'#fff'"
            :borderradius="'2.5rem'"
            :btncolor="'#333'"
            :fontsize="'1.7rem'"
            :fontweight="700"
            :btnborder="'solid 0.1rem #666'"
            @btnClick="goBack"
          />
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailInfo: {},
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-2);
      } else {
        this.$router.go(-1);
      }
    },
    getInfo() {
      this.$api
        .get("member-relation/member/supplier/withdrawal/detail", {
          id: this.$route.query.id,
        })
        .then((res) => {
          this.detailInfo = res;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.withdraw_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .withdraw_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 10.4rem 0 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .van-row {
      min-height: 43.1rem;
      padding: 2.6rem 3.3rem 3.6rem;
      background: #fff;
      box-sizing: border-box;

      .operate_status {
        margin-bottom: 3.6rem;
        padding-bottom: 0.7rem;
        border-bottom: solid 0.05rem #eeeeee;

        .step {
          height: 4.5rem;
          color: #999;
          padding-left: 4.8rem;
          margin-bottom: 1.3rem;
          position: relative;

          .tit {
            height: 2.4rem;
            line-height: 2.4rem;
            font-size: 1.3rem;
          }

          .time {
            height: 2.1rem;
            line-height: 2.1rem;
            font-size: 1.2rem;
          }

          img {
            position: absolute;
            top: 1.2rem;
            left: 0.8rem;
            width: 2rem;
            height: 2rem;
            z-index: 2;
          }

          .line {
            position: absolute;
            top: 3.2rem;
            left: 1.8rem;
            width: 0.2rem;
            height: 4.5rem;
            display: inline-block;
            background: #f9591b;
            z-index: 1;
          }
        }

        .current {
          height: 4.7rem;
          padding-top: 0.2rem;

          .tit {
            color: #333;
            font-size: 1.5rem;
          }

          .time {
            font-size: 1.3rem;
          }

          img {
            position: absolute;
            top: 0.6rem;
            left: 0;
            width: 3.6rem;
            height: 3.6rem;
          }
        }

        .middle {
          height: 4.5rem;
          padding-top: 0;
          margin-bottom: 2.4rem;

          img {
            top: 0.5rem;
            left: 0;
          }
          .line {
            width: 0;
            background: #fff;
            border-left: dashed 2px #fdbda4;
          }
        }

        .nature {
          height: 2.4rem;
          margin-bottom: 3.6rem;

          .tit {
            font-size: 1.5rem;
          }

          img {
            top: 0.2rem;
          }
          .line {
            top: 2rem;
            width: 0;
            background: #fff;
            border-left: dashed 2px #fdbda4;
          }
        }

        .last {
          margin-bottom: 1.6rem;
        }
      }

      .item {
        line-height: 2.4rem;
        color: #999;
        font-size: 1.5rem;
        margin-bottom: 0.9rem;

        span {
          color: #999;
          font-size: 1.5rem;
          float: right;
          max-width: 18.7rem;
          text-align: right;
        }
      }

      .last {
        margin-bottom: 3.6rem;
      }
    }
  }
}
</style>


